// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2amhF","header":"PatientBlock_header__3dG9d","label":"PatientBlock_label__2FqrZ","option":"PatientBlock_option__2jNda"};